import { useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import CurrencyInput from "react-currency-input";
import { useNavigate } from "react-router-dom";
import DiscountService from "../../../services/DiscountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Checkbox } from "@mui/material";

const AddConditionCommercial = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const [name, setName] = useState();
  const [startDate, setStartDate] = useState("any");

  const [endDate, setEndDate] = useState("any");
  const [percent, setPercent] = useState(0);
  const [amount, setAmount] = useState(0);

  const [description, setDescription] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
 
  const onChangePercentHandler = (event) => {
    setPercent(event.target.value);
  };
  const onChangeAmountHandler = (event) => {
    setAmount(event.target.value);
  };
  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };
  const onChangeStartDate = (event) => {
    setStartDate(event.target.value.concat(":59"));
  };
  const onChangeEndDate = (event) => {
    setEndDate(event.target.value.concat(":59"));
  };
  const onChangeDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };

  const onValidFamilyHandler = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le nom est vide ! ");
    } else {
      let promotionCCAddModel = {
        libelle: name,
        description: description,
        idUser: getCurrentUserId(),
        dateDebut: startDate,
        dateFin: endDate,
        amount: amount,
        percent: percent,
      };
      console.log("promotionCCAddModel", promotionCCAddModel);
      startLoading();
      DiscountService.addConditionsCommercialTiers(promotionCCAddModel)
        .then((response) => {
          console.log("response", response.data["success"]);
          if (response.data.success) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/conditionscommercials`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((e) => {
          console.log("error in allDiscounts", e);
        })
        .finally(() => {
          stopLoading();
        });
    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">
                  Ajouter Condition Commercial
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card ">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter Condition Commercial</h5>
                </div>
                <div class="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Libellé</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <textarea
                          value={description}
                          placeholder="Saisir..."
                          onChange={onChangeDescriptionHandler}
                          id="inputDescription"
                          className="form-control"
                          rows={4}
                          defaultValue={""}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-5">
                      <div className="input-group">
                        <label>Pourcentage Promotion</label>{" "}
                        <div
                          className="input-group-prepend"
                          style={{ width: "90%" }}
                        >
                          <CurrencyInput
                            id="percent"
                            className="form-control"
                            precision="3"
                            value={percent}
                            onChangeEvent={onChangePercentHandler}
                          />
                        </div>
                        <div className=" input-group-append">
                          <button type="button" class="btn btn-dark">
                            {" "}
                            <i class="fas fa-solid fa-percent"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="input-group">
                        <label>Ou</label>{" "}
                      </div>
                    </div>
                    <div className="col-sm-5">
                      <div className="input-group">
                        <label>Montant Promotion</label>{" "}
                        <div
                          className="input-group-prepend"
                          style={{ width: "90%" }}
                        >
                          <CurrencyInput
                            id="amount"
                            className="form-control"
                            precision="3"
                            value={amount}
                            onChangeEvent={onChangeAmountHandler}
                          />
                        </div>
                        <div className=" input-group-append">
                          <button type="button" class="btn btn-dark">
                            {" "}
                            <i class="fas fa-dollar-sign"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
              
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={startDate}
                          onChange={onChangeStartDate}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={endDate}
                          onChange={onChangeEndDate}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidFamilyHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddConditionCommercial);
